var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.responsive == 'PC')?_c('div',{staticStyle:{"height":"360px"},attrs:{"id":_vm.id}}):_vm._e(),(_vm.responsive == 'mobile' || _vm.responsive == 'pad')?_c('div',{staticStyle:{"height":"290px"},attrs:{"id":_vm.id}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }